import apiClient from '@/services/axios'

export const del = async (id) => {
    const response = await apiClient.delete(`/mediaspace/${id}`)
    return response.data
} 